module.exports = __webpack_public_path__ + "media/images/icons/icon-check-ecdbf373362430b953aab70ddcd774b4.svg";